import React from "react";
import { useAppState } from "../state/AppStateContext";
import { t } from "../i18n/strings";
import { colorForScore, scoreText, verdictForScore } from "../utils/scoring";

export default function HistoryScreen() {
  const { history, deletePlate, openTaxi, lang } = useAppState();
  return (
    <section style={styles.screen}>
      <h1 style={styles.title}>{t(lang, "historyTitle")}</h1>
      {!history.length ? <p style={styles.empty}>{t(lang, "noHistory")}</p> : (
        <div style={styles.list}>{history.map((item) => {
          const color = colorForScore(item.score);
          return (
            <article key={item.plate} style={styles.item}>
              <div style={{ ...styles.score, background: color }} aria-label={`${scoreText(item.score)} ${t(lang, "scoreOutOfFive")}`}><strong>{scoreText(item.score)}</strong><small aria-hidden="true">/5</small></div>
              <button type="button" style={styles.open} onClick={() => openTaxi(item.plate)}>
                <span style={styles.plate}>{item.plate}</span><span style={{ ...styles.verdict, color }}>{verdictForScore(item.score, lang)}</span>
              </button>
              <button type="button" className="btn btn-icon" aria-label={t(lang, "removePlate", { plate: item.plate })} style={styles.remove} onClick={() => deletePlate(item.plate)}>✕</button>
            </article>
          );
        })}</div>
      )}
    </section>
  );
}

const styles = {
  screen: { padding: "18px 18px 28px" }, title: { margin: "4px 0 16px", fontFamily: "var(--font-heading)", fontSize: 24 },
  empty: { padding: "60px 20px", textAlign: "center", color: "var(--color-neutral-600)" }, list: { display: "flex", flexDirection: "column", gap: 12 },
  item: { display: "flex", alignItems: "center", gap: 12, padding: "12px 14px", borderRadius: 20, background: "var(--panel)", boxShadow: "var(--shadow-sm)" },
  score: { width: 58, height: 58, flex: "none", borderRadius: 16, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", color: "#04241f" },
  open: { flex: 1, minWidth: 0, display: "flex", flexDirection: "column", alignItems: "flex-start", border: 0, background: "none", color: "inherit", cursor: "pointer" },
  plate: { fontFamily: "var(--font-heading)", fontSize: 19, letterSpacing: 1 }, verdict: { marginTop: 2, fontSize: 13, fontWeight: 600 }, remove: { color: "var(--color-neutral-600)" },
};
